/* eslint-disable react/prop-types */
import React, { useState } from "react"; // React Stuff
//Packages
import axios from "axios";
import { Row, Button, Col, Form, InputGroup } from "react-bootstrap";
//Images and Icons
import { MdDeleteForever } from "react-icons/md";

const ClassTypeEditForm = (props) => {
    // Extract the data from the selected class Type
    const typeSelected = props.classTypes.find((x) => {
      return x._id === props.classTypeForEdit;
    });
    console.log(typeSelected);
    const oldClassType = typeSelected.Type; // Does not change. Is used to replace.
    const lowerAgeNumber = Number(typeSelected.LowerAgeString.replace(/\D/g, ""));
    const upperAgeNumber = Number(typeSelected.UpperAgeString.replace(/\D/g, ""));
    const lowerAgeSpan = typeSelected.LowerAgeString.replace(/[0-9]/g, "");
    const upperAgeSpan = typeSelected.UpperAgeString.replace(/[0-9]/g, "");
    // Set the States
    const [Type, setType] = useState(typeSelected.Type);
    const [LowerAge, setLowerAge] = useState(lowerAgeNumber);
    const [LowerAgeRange, setLowerAgeRange] = useState(lowerAgeSpan);
    const [UpperAge, setUpperAge] = useState(upperAgeNumber);
    const [UpperAgeRange, setUpperAgeRange] = useState(upperAgeSpan);
    const [ShortDescription, setShortDescription] = useState(typeSelected.ShortDescription);
    const [CriteriaDisplay, setCriteriaDisplay] = useState("");
    const [Criteria, setCriteria] = useState("");
    const [GradingListData, setGradingListData] = useState(typeSelected.GradingList);
    // Grading List
    const GradingListSize = GradingListData.length;
    const gradingList = GradingListData;
  
    // Add a grading crtiteria
    const addCriteria = () => {
      if (GradingListData.length < 12) {
        setGradingListData(GradingListData.concat(Criteria));
        setCriteriaDisplay("");
        return setCriteria("");
      }
    };
  
    //Remove a grading criteria
    const removeCriteria = (e, i) => {
      e.preventDefault();
      const newGradingList = [...GradingListData];
      if (i !== -1) {
        newGradingList.splice(i, 1);
        setGradingListData(newGradingList);
      }
    };
  
    // Submit the Class Type
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      props.setSubmitClicked(true);
      let GradingList;
      if (GradingListData.length === 0) {
        GradingList = ["None"];
      } else {
        GradingList = GradingListData;
      }
      //Construct the age Strings
      const LowerAgeString = LowerAge + LowerAgeRange;
      const UpperAgeString = UpperAge + UpperAgeRange;
      // Make the data packet
      const data = {
        Type,
        ShortDescription,
        UpperAgeString,
        LowerAgeString,
        GradingList,
        oldClassType,
      };
      // Make the API call
      const requestEditClassType = await axios.put("/api/admin/manage/class_types/edit", data, {
        withCredentials: true,
      });
      if (requestEditClassType.status === 200) {
        props.setSubmitClicked(false);
        props.setSuccessMessage("Successfully saved the class changes.");
        window.scrollTo(10, 0);
        props.setViewMode("view");
        return props.fetchNewData();
      } else {
        props.setSubmitClicked(false);
        window.scrollTo(10, 0);
        return props.setErrorMessage("There was a problem with your request.");
      }
    };
  
    return (
      <Row className='mt-4 mb-4 text-center'>
        <Col sm='12'>
          <div className='mx-1 mt-3 p-2 shadow text-center border'>
            <h2 className='mt-3'>Edit Class Type</h2>
            <Form className='post' onSubmit={handleSubmit}>
              <Row>
                <Col sm='12' className='mt-2  pl-3 pr-3'>
                  <Form.Group controlId='ClassTypeForm1'>
                    <Form.Label>Title/Type</Form.Label>
                    <Form.Control
                      type='text'
                      maxLength='256'
                      value={Type}
                      onChange={(e) => setType(e.target.value)}
                      className='border'
                      required
                    />
                    <Form.Text className='text-muted'>
                      The <strong>unique</strong> title you want to display.
                    </Form.Text>
                  </Form.Group>
                </Col>
                </Row>
                <Row>
                <Col sm='6' md='4' className='mt-2  pl-3'>
                  <Form.Group controlId='ClassTypeForm2'>
                    <Form.Label>Lower Age</Form.Label>
                    <Form.Control
                      type='number'
                      min='0'
                      max='130'
                      value={LowerAge}
                      onChange={(e) => setLowerAge(e.target.value)}
                      className='border'
                      required
                    />
                    <Form.Text className='text-muted'>Number</Form.Text>
                  </Form.Group>
                </Col>
                <Col sm='6' md='2' className='mt-2 pr-3'>
                  <Form.Group controlId='ClassTypeForm3'>
                    <Form.Label>Range</Form.Label>
                    <Form.Control
                      as='select'
                      value={LowerAgeRange}
                      onChange={(e) => setLowerAgeRange(e.target.value)}
                      required
                      custom
                      className='border'
                    >
                      <option value='' disabled defaultValue>
                        Select
                      </option>
                      <option value='mths'>Months</option>
                      <option value='yrs'>Years</option>
                    </Form.Control>
                    <Form.Text className='text-muted'>Months/Years.</Form.Text>
                  </Form.Group>
                </Col>
  
                <Col sm='6' md='4' className='mt-2  pl-3'>
                  <Form.Group controlId='ClassTypeForm4'>
                    <Form.Label>Upper Age</Form.Label>
                    <Form.Control
                      type='number'
                      min='0'
                      max='130'
                      value={UpperAge}
                      onChange={(e) => setUpperAge(e.target.value)}
                      className='border'
                      required
                    />
                    <Form.Text className='text-muted'>Number</Form.Text>
                  </Form.Group>
                </Col>
                <Col sm='6' md='2' className='mt-2 pr-3'>
                  <Form.Group controlId='ClassTypeForm5'>
                    <Form.Label>Range</Form.Label>
                    <Form.Control
                      as='select'
                      value={UpperAgeRange}
                      onChange={(e) => setUpperAgeRange(e.target.value)}
                      required
                      custom
                      className='border'
                    >
                      <option value='' disabled defaultValue>
                        Select
                      </option>
                      <option value='mths'>Months</option>
                      <option value='yrs'>Years</option>
                    </Form.Control>
                    <Form.Text className='text-muted'>Months/Years.</Form.Text>
                  </Form.Group>
                </Col>
              </Row>
  
              <Form.Group controlId='ClassTypeForm6'>
                <Form.Label>Short Description</Form.Label>
                <Form.Control
                  as='textarea'
                  type='text'
                  maxLength='1000'
                  value={ShortDescription}
                  onChange={(e) => setShortDescription(e.target.value)}
                  className='border'
                  required
                />
                <Form.Text className='text-muted'>
                  Up to 1000 character description of the type of class this is.
                </Form.Text>
              </Form.Group>
  
              <div className='text-center'>
                <h4>Grading Criteria</h4>
                <p>
                  Grading criteria can be used to create report cards later. You can have up to 12 per
                  class type. Their use is optional.
                </p>
                {gradingList.length > 0 && (
                  <div>
                    {gradingList.map((item, i) => (
                      <span
                        key={i}
                        className='me-2 text-center shadow border p-1 mt-1 d-block d-md-inline-block'
                        value={i}
                        onClick={(e) => {
                          removeCriteria(e, i);
                        }}
                      >
                        {item}
                        <MdDeleteForever />
                      </span>
                    ))}
                  </div>
                )}
              </div>
  
              <InputGroup className='mb-2'>
                <InputGroup.Text>
                  <InputGroup.Text>Criteria Name</InputGroup.Text>
                </InputGroup.Text>
                <Form.Control
                  type='text'
                  maxLength='64'
                  className='border'
                  value={CriteriaDisplay}
                  onChange={(e) => {
                    setCriteriaDisplay(e.target.value);
                    setCriteria(e.target.value.trim());
                  }}
                />
                {GradingListSize <= 11 && (
                  <InputGroup.Text>
                    <Button
                      variant='secondary'
                      type='button'
                      className='inputGroupBtn'
                      onClick={addCriteria}
                    >
                      Add
                    </Button>
                  </InputGroup.Text>
                )}
              </InputGroup>
  
              <Col className='mt-4 mb-2'>
                <Button variant='primary' type='submit'>
                  Edit Class Type
                </Button>
              </Col>
            </Form>
          </div>
        </Col>
      </Row>
    );
  };

  export default ClassTypeEditForm;